import { getCurrentLanguage } from '../services/dataSync';

const normalizeLang = (lang) => (lang === 'mr' || lang === 'hi' ? lang : 'en');

export const getPlanLocalizedText = (plan, field, lang = getCurrentLanguage()) => {
  const selectedLang = normalizeLang(lang);
  const primary = plan?.[field];
  const translations = plan?.translations?.[field];

  if (primary && typeof primary === 'object' && !Array.isArray(primary)) {
    return primary[selectedLang] || primary.en || primary.mr || primary.hi || '';
  }

  if (translations && typeof translations === 'object' && !Array.isArray(translations)) {
    return translations[selectedLang] || primary || translations.en || translations.mr || translations.hi || '';
  }

  return primary || '';
};

export const getPlanLocalizedFeatures = (plan, lang = getCurrentLanguage()) => {
  const selectedLang = normalizeLang(lang);
  if (Array.isArray(plan?.features)) {
    if (selectedLang === 'en') return plan.features;
    const translated = plan?.translations?.features?.[selectedLang];
    return Array.isArray(translated) && translated.length > 0 ? translated : plan.features;
  }
  if (plan?.features && typeof plan.features === 'object') {
    return plan.features[selectedLang] || plan.features.en || [];
  }
  return [];
};

const getLocalizedTrainingArray = (plan, key, lang = getCurrentLanguage()) => {
  const selectedLang = normalizeLang(lang);
  const base = Array.isArray(plan?.trainingProgram?.[key]) ? plan.trainingProgram[key] : [];
  if (selectedLang === 'en') return base;

  const translated = plan?.translations?.trainingProgram?.[key]?.[selectedLang];
  return Array.isArray(translated) && translated.length > 0 ? translated : base;
};

export const withLocalizedPlan = (plan, lang = getCurrentLanguage()) => ({
  ...plan,
  name: getPlanLocalizedText(plan, 'name', lang),
  alternativeName: getPlanLocalizedText(plan, 'alternativeName', lang),
  description: getPlanLocalizedText(plan, 'description', lang),
  features: getPlanLocalizedFeatures(plan, lang),
  trainingProgram: plan?.trainingProgram
    ? {
        ...plan.trainingProgram,
        trainingAreas: getLocalizedTrainingArray(plan, 'trainingAreas', lang),
        outcomes: getLocalizedTrainingArray(plan, 'outcomes', lang)
      }
    : plan?.trainingProgram
});
